

export class FilteringDefinitions {
    constructor() {
        this.salaryTypeDefinition = null;
        this.distanceDefinition = null;
        this.datePostedDefinition = null;
        this.jobTypeDefinition = null;
        this.featureDefinition = null;
        this.dataFetched = false; // データが取得されたかどうかを示す
    }

    async fetchData() {
        try {
            if (!this.dataFetched) {
                const response = await fetch('/api/filter-definitions');
                const data = await response.json();
                this.salaryTypeDefinition = Object.freeze(data.filteringDefinitions.salaryTypeDefinition);
                this.distanceDefinition = Object.freeze(data.filteringDefinitions.distanceDefinition);
                this.datePostedDefinition = Object.freeze(data.filteringDefinitions.datePostedDefinition);
                this.jobTypeDefinition = Object.freeze(data.filteringDefinitions.jobTypeDefinition);
                this.featureDefinition = Object.freeze(data.filteringDefinitions.featureDefinition);
                this.dataFetched = true;
            }
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
        return this;
    }
}
